var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmTheDateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#3B9849"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3199 12.6641H22.2044C22.9214 12.6641 23.5016 13.2443 23.5016 13.9613V22.2055C23.5016 22.9217 22.9214 23.5019 22.2044 23.5019H13.1273C12.4103 23.5019 11.8301 22.9217 11.8301 22.2047V21.0009",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33069 21.0016H18.7613C19.319 21.0016 19.8392 20.7232 20.1485 20.2588L20.7604 19.3401C21.1256 18.7924 21.3207 18.1488 21.3207 17.4901V10.9974C21.3207 10.0762 20.5745 9.33008 19.6533 9.33008H11.3165C10.3953 9.33008 9.64915 10.0762 9.64915 10.9974V16.8799C9.64915 17.3976 9.52827 17.9078 9.29734 18.3713L8.58538 19.7953C8.30776 20.3497 8.71126 21.0016 9.33069 21.0016Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3754 13.9922L15.0303 16.3373L13.623 14.9309",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9813 8.49609V10.1635",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9832 8.49609V10.1635",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmTheDateIcon);
export default __webpack_public_path__ + "static/media/ConfirmTheDateIcon.91734bd60a3df4004d27cbbbe5d39297.svg";
export { ForwardRef as ReactComponent };